import { all, takeEvery } from 'redux-saga/effects';
import logListActions from './actions';
import Api from '../../../../helpers/api';
import { getLoadData } from '../../../../components/logs/saga';

const api = new Api('applicants/:id/logs');
const loadData = getLoadData(logListActions, api);

export default function* rootSaga() {
  yield all([takeEvery(logListActions.LOAD, loadData)]);
}
